import axios from "axios";
import constants from "constants";
import { store } from "store";
import errorHandler from "./errorHandler";

/*
    TODO Write a network layer before axios,
    Handle cancellation of network call or ignoring stale response
    Camelize all api keys at deep level
*/

const central = axios.create({
	baseURL: `${constants.centralApiServerUrl}/`,
});
central.interceptors.request.use((config) => {
	let userInfo = store.getState().userInfo;
	config.headers[constants.authTokenBackendKey] = userInfo.authToken;
	config.headers["sessionID"] = userInfo.sessionId;
	config.headers["redirectToAuth"] = true;
	return config;
});

central.interceptors.response.use(function (response) {
	return response;
}, errorHandler);

export default central;
